import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientAPI } from "./axiosAnstance";
import fileDownload from "js-file-download";
import axios from "axios";
import { SERVER_URL } from "src/serverConfig";
import { getAuthHeader } from "src/jwt/config";
import {verifierConjointAPI} from "./ConjointSlice";

export const getAdherentDetailsAPI = createAsyncThunk(
  "adherentDetails/searchAdherent",
  async (compte) => {
    const response = await clientAPI.get("/api/compte/info/" + compte);

    return response.data;
  }
);

export const verifierCompteAPI = createAsyncThunk(
  "adherentDetails/verifierCompte",
  async (idCompte) => {
    const response = await clientAPI.put(`/api/compte/verify/${idCompte}`);
    return response.data;
  }
);
export const updateCompteVerificationAPI = createAsyncThunk(
  "adherentDetails/updateVerification",
  // ✅ On déstructure { id, status } ici
  async ({ id, status }) => {
    // ✅ On utilise les variables id et status, pas l'objet
    const response = await clientAPI.put(`/api/compte/verify/${id}?status=${status}`);
    return response.data;
  }
);

export const imprimerFicheAdherentAPI = createAsyncThunk(
  "adherentDetails/imprimerFicheAdherent",
  async (idCompte) => {
    let token = localStorage.getItem("token");
    return axios
      .get(SERVER_URL + `/api/report/fiche-compte?idCompte=${idCompte}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob",
      })
      .then((res) => {
        fileDownload(res.data, "fiche-adherent.pdf");
      });
  }
);

const AdherentDetailsSlice = createSlice({
  name: "adherentDetails",
  initialState: { details: {},verifyCompteStatus: null }, // enfants: []
  reducers: {
    resetAdherentDetails: (state, action) => {
      state.details = {};
    },
  },
  extraReducers: {
    [updateCompteVerificationAPI.pending]: (state) => {
      state.verifyCompteStatus = "pending";
    },
    [updateCompteVerificationAPI.fulfilled]: (state) => {
      state.verifyCompteStatus = "fulfilled";
    },
    [updateCompteVerificationAPI.rejected]: (state) => {
      state.verifyCompteStatus = "rejected";
    },

    [getAdherentDetailsAPI.fulfilled]: (state, action) => {
      // let listEnfants = [];
      // console.log("action.payload.conjoints ", action.payload.conjoints);
      // if (action.payload && action.payload.conjoints) {
      //   const conjointsList = action.payload.conjoints;
      //   for (let index = 0; index < conjointsList.length; index++) {
      //     const conjoint = conjointsList[index];
      //     console.log("conjoint ==> ", conjoint);
      //     listEnfants = listEnfants.concat(conjoint.enfants);
      //   }
      //   console.log("last loop ", listEnfants);
      //   state.enfants = listEnfants;
      // }

      // -------------- verifierConjointAPI ----------------

      state.details = action.payload;
    },
  },
});

export const { resetAdherentDetails } = AdherentDetailsSlice.actions;
export const verifyCompteStatusSelector = (state) => state.adherentDetails.verifyCompteStatus;

export default AdherentDetailsSlice.reducer;
